<template>
  <div class="el-menu-main">
    <div class="brand">
      <div class="logo">
        <img src="@/assets/logo/logo-reduccion.png" :alt="`Kudenix Logo`" />
      </div>
      <div class="name">CARGADOR DE PRODUCTO</div>
    </div>
    <div class="menu"></div>
    <div class="option-memu">
      <el-button @click="drawerShow">
        <IconMenu />
      </el-button>
    </div>
  </div>
</template>

<script setup>
import useNavigationStore from '@/stores/navigation.js'
import IconMenu from '@/components/icons/IconMenu.vue'

const navigation = useNavigationStore()

const drawerShow = () => {
  navigation.drawer = !navigation.drawer
}
</script>
<style lang="scss">
.el-menu-main {
  display: grid;
  grid-template-columns: 120px 1fr 40px;
  align-items: center;
  height: 100%;
  .menu {
    margin-left: auto;
    min-width: 200px;
    align-items: center;
    @media (max-width: 478px) {
      display: flex;
      min-width: auto;
      height: 100%;
    }
  }
  .option-memu {
    display: flex;
    place-items: center;
    button {
      background-color: transparent;
      border: 0;
    }
  }
  .brand {
    display: flex;
    align-items: center;
    gap: 8px;
    .logo {
      display: flex;
      align-items: center;
      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }
    }
    .name {
      @media (max-width: 478px) {
        display: none;
      }
    }
  }
}
</style>
